// extracted by mini-css-extract-plugin
export default {"table":"PresentEdits_table__J7D6e"};